(function () {
  'use strict';

  /* ── Reveal on scroll ──────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.bp-store-reveal');
    if (!els.length) return;
    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Generic carousel ──────────────────────────────────── */
  function makeCarousel(opts) {
    var slides = opts.slides;
    var dots   = opts.dots || [];
    var total  = slides.length;
    if (!total) return;

    var current = 0;
    var timer   = null;
    var paused  = false;

    function activate(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = ((n % total) + total) % total;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { activate(current + 1); }
    function prev() { activate(current - 1); }

    function startTimer() {
      clearTimeout(timer);
      if (opts.interval && !paused) {
        timer = setTimeout(function () { next(); startTimer(); }, opts.interval);
      }
    }

    slides[0].classList.add('is-active');
    if (dots[0]) dots[0].classList.add('is-active');
    startTimer();

    if (opts.prevBtn) opts.prevBtn.addEventListener('click', function () { prev(); startTimer(); });
    if (opts.nextBtn) opts.nextBtn.addEventListener('click', function () { next(); startTimer(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { activate(i); startTimer(); });
    });

    if (opts.pauseOnHover && opts.root) {
      opts.root.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); });
      opts.root.addEventListener('mouseleave', function () { paused = false; startTimer(); });
    }

    if (opts.swipe && opts.root) {
      var tx = null;
      opts.root.addEventListener('touchstart', function (e) {
        tx = e.touches[0].clientX;
        paused = true;
        clearTimeout(timer);
      }, { passive: true });
      opts.root.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        tx = null;
        paused = false;
        if (Math.abs(dx) > 50) { dx < 0 ? next() : prev(); }
        startTimer();
      }, { passive: true });
    }
  }

  /* ── Hero carousel ─────────────────────────────────────── */
  function initHero() {
    var root = document.querySelector('.bsh');
    if (!root) return;
    makeCarousel({
      slides:       Array.from(root.querySelectorAll('.bsh__slide')),
      dots:         Array.from(root.querySelectorAll('.bsh__dot')),
      prevBtn:      root.querySelector('.bsh__nav-btn--prev'),
      nextBtn:      root.querySelector('.bsh__nav-btn--next'),
      interval:     6500,
      pauseOnHover: true,
      swipe:        true,
      root:         root
    });
  }

  /* ── Story slideshow ───────────────────────────────────── */
  function initStorySlideshow() {
    var wrap = document.querySelector('.bsos__slideshow');
    if (!wrap) return;
    var slides = Array.from(wrap.querySelectorAll('.bsos__ss-img'));
    if (slides.length <= 1) {
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }
    makeCarousel({
      slides:   slides,
      dots:     Array.from(wrap.querySelectorAll('.bsos__ss-dot')),
      interval: 5000
    });
  }

  /* ── Testimonials carousel ─────────────────────────────── */
  function initTestimonials() {
    var root = document.querySelector('.bstm');
    if (!root) return;
    makeCarousel({
      slides:  Array.from(root.querySelectorAll('.bstm__slide')),
      dots:    Array.from(root.querySelectorAll('.bstm__dot')),
      prevBtn: root.querySelector('.bstm__nav-btn--prev'),
      nextBtn: root.querySelector('.bstm__nav-btn--next'),
      interval: 6000
    });
  }

  /* ── Init ──────────────────────────────────────────────── */
  function init() {
    initReveal();
    initHero();
    initStorySlideshow();
    initTestimonials();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
